class UploadAdapter {
  constructor(loader) {
    this.loader = loader;
  }

  upload() {
    return this.loader.file.then(
      (file) =>
        new Promise((resolve, reject) => {
          try {
            this.salvarImagemTemporaria(resolve, file);
          } catch (error) {
            reject(`Erro ao salvar a imagem temporária: ${error}`);
          }
        })
    );
  }

  abort() {
    //
  }

  async salvarImagemTemporaria(resolve, file) {
    const blob = await this.fileToBlob(file);
    const caminhoTemporario = URL.createObjectURL(blob);

    resolve({
      default: caminhoTemporario,
    });
  }

  async fileToBlob(file) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const arrayBuffer = reader.result;
        const blob = new Blob([arrayBuffer], { type: file.type });
        resolve(blob);
      };
      reader.readAsArrayBuffer(file);
    });
  }
}

export default UploadAdapter;
